import React, {useEffect, useState} from "react";
import {useStore} from "../../../hooks/useStore";
import {SelectField} from "./FilterComponentStyles";
import {useObserver} from "mobx-react-lite";

const SubCompanyWorkTypeFilter = ({showAllOption = false, value, onChange}) => {
    const stores = useStore();
    const [initialValue, setInitialValue] = useState(value);

    useEffect(() => {
        if (stores.meStore.map.filters.workType) {
            setInitialValue(stores.meStore.map.filters.workType);
            onChange(stores.meStore.map.filters.workType);
        }
    }, []);

    const handleSubcompanyType = value => {
        stores.meStore.map.filters.workType = value;
        onChange(value);
    };

    return useObserver(() => (
        <React.Fragment>
            <h5>Alt firma tipi</h5>
            <SelectField
                value={initialValue || "dedicated"}
                data-testid="workTypeFilter"
                onChange={handleSubcompanyType}
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="workTypeFilter_option">
                        Tümü
                    </SelectField.Option>
                )}
                <SelectField.Option value="pool" data-testid="workTypeFilter_option">
                    Havuz
                </SelectField.Option>
                <SelectField.Option value="dedicated" data-testid="workTypeFilter_option">
                    Sabit
                </SelectField.Option>
            </SelectField>
        </React.Fragment>
    ));
};

export default SubCompanyWorkTypeFilter;
